import { Box, Tooltip, useTheme } from "@mui/material";
import { tokens } from "../../../theme";
import CloudIcon from "../../../components/CloudIcon";
import SectionCard from "./SectionCard";
import DetailRow from "./DetailRow";
import { detailRowStyles as styles } from "./styles";
import { sentenceCase } from "./utils";

// cloud_deployment_type and clouds[] are two distinct infra concerns, not one
// combined idea (confirmed against convoy-devops-service source): the single
// cloud_deployment_type is where the CONTROL PLANE's own k8s cluster runs
// (routers/tenant_environments.py:create -> get_deployment_name(global_site,
// cloud_deployment_type)); clouds[] is which cloud(s) the tenant's DATA PLANE
// is enabled across (it's fed from RequestsControlPlane.data_plane_clouds via
// utils/requests/control_plane.py:53 on the request-approval path). Kept as
// separate rows so the drawer doesn't imply they're the same thing.
const InfrastructureCard = ({ row }) => {
  const theme = useTheme();
  const colors = tokens(theme.paletteId);
  const meta = row?.meta;

  const dataPlaneClouds = Array.isArray(meta?.clouds) ? meta.clouds : [];

  const servicePlan = meta?.service_plan
    ? sentenceCase(meta.service_plan)
    : null;
  const deploymentType = meta?.infra_deployment_type
    ? sentenceCase(meta.infra_deployment_type)
    : null;

  const hasAnyField =
    servicePlan ||
    deploymentType ||
    meta?.cloud_deployment_type ||
    meta?.deployment_name ||
    meta?.k8s_cluster_name ||
    meta?.repository_info?.k8s_namespace ||
    dataPlaneClouds.length;
  if (!hasAnyField) return null;

  return (
    <SectionCard title="Infrastructure">
      <DetailRow label="Service plan" value={servicePlan} />
      <DetailRow label="Deployment type" value={deploymentType} />
      <DetailRow
        label="Control plane cloud"
        value={meta?.cloud_deployment_type}
        icon={<CloudIcon cloud={meta?.cloud_deployment_type} />}
        hideText
      />
      <DetailRow label="Deployment" value={meta?.deployment_name} mono />
      <DetailRow
        label="K8s cluster"
        value={meta?.k8s_cluster_name}
        mono
        copyable
      />
      <DetailRow
        label="Namespace"
        value={meta?.repository_info?.k8s_namespace}
        mono
        copyable
      />
      {dataPlaneClouds.length ? (
        <Box sx={styles.row(colors)}>
          <Box sx={styles.label(colors)}>Data plane clouds</Box>
          <Box
            sx={{
              flex: 1,
              minWidth: 0,
              display: "flex",
              alignItems: "center",
              gap: "10px",
              flexWrap: "wrap",
            }}
          >
            {dataPlaneClouds.map((cloud) => (
              <Tooltip key={cloud} title={cloud}>
                <Box sx={{ display: "flex" }}>
                  <CloudIcon cloud={cloud} />
                </Box>
              </Tooltip>
            ))}
          </Box>
        </Box>
      ) : null}
    </SectionCard>
  );
};

export default InfrastructureCard;
